import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioProcedimientosAdmisionService {

  constructor( private requestUrl: ReportesRequestService) { }

  async getEmpresas(objetoParametros: ParametrosProcedimientosAdmisionEntity) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'admision/empresas',
        [ objetoParametros.codigoBaseDatos, { uncoAdmision : objetoParametros.uncoAdmision } ]
      );
      return response;
    } catch (e) {
      console.error('ServicioProcedimientosAdmisionService.getEmpresa()', e);
    }
    return null;
  }

  async getProcedimientos( codigoBaseDatos: string, uncoAdmision: number,  uncoEmpresa: number) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'admision/procedimientos',
        [ codigoBaseDatos, { uncoAdmision, uncoEmpresa } ]);
      return response;
    } catch (e) {
      console.error('ServicioProcedimientosAdmisionService.getProcedimientos()', e);
    }
    return null;
  }

  async getBody (f: FiltrosProcedimientosAdmisionEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'admision/procedimientos',
        [
          f.codigoBaseDatos,
          {
            uncoAdmision : f.uncoAdmision,
            uncoEmpresa : f.uncoEmpresa,
            procedimientos : f.procedimientos,
            inicio : f.fechaInicial.getTime(),
            fin : f.fechaFinal.getTime()
          }
      ]);
      return response;
    } catch (e) {
      console.error('ServicioProcedimientosAdmisionService.getBody()', e);
    }
    return null;
  }

}

export interface ParametrosProcedimientosAdmisionEntity {
  codigoBaseDatos ?: string;
  uncoSede ?: string;
  uncoLogin ?: string;
  uncoAdmision ?: string;
}

export interface FiltrosProcedimientosAdmisionEntity {
  codigoBaseDatos ?: string;
  uncoAdmision ?: number;
  uncoEmpresa ?: number;
  procedimientos ?: string;
  fechaInicial ?: Date;
  fechaFinal ?: Date;
}

export interface BodyProcedimientosAdmisionEntity {
  afiliado: string;
  consecutivoAdmisiones: string;
  empresa: string;
  fechaAdmision: number;
  fechaSalidaAdmision?: any;
  codigoSede: string;
  sede: string;
  codigoPuntoAtencion: string;
  puntoAtencion: string;
  tipoAfiliado: string;
  tipoDocumento: string;
  genero: string;
  rangoSalarial: string;
  numeroIdentificacion: string;
  fechaNacimiento: number;
  edad: string;
  codigoProcedimiento: string;
  procedimiento: string;
  fechaOrden: string;
  cantidad: number;
  valorUnitario: number;
  usuarioModificacion: string;
}

export interface HeadProcedimientosAdmisionEntity {
  consecutivoAdmision: string;
  sede: string;
  puntoAtencion: string;
  tipoDocumento: string;
  numeroIdentificacion: string;
  fechaNacimiento: number;
  afiliado: string;
  empresa: string;
  edad: string;
  fechaAdmision: number;
  fechaSalidaAdmision?: any;
  rangoSalarial: string;
  tipoAfiliado: string;
}
